import { Theme } from '@mui/material'
import { makeStyles } from '@mui/styles'
import { FONTS, SPACES } from 'src/constants'

const useStyles = makeStyles((theme: Theme) => ({
  paper: {
    display: 'flex',
    flexDirection: 'column',
    gap: SPACES.l,

    backgroundColor: theme.palette.background.paper,
    borderRadius: 15,
    boxShadow: theme.shadows[5],

    [theme.breakpoints.down('tablet')]: {
      padding: `${SPACES.xxxxxl} ${SPACES.xxl} ${SPACES.xxl} ${SPACES.xxl}`,

      // minHeight: 508,
      width: 'calc(100% - 40px)',
    },

    [theme.breakpoints.up('tablet')]: {
      padding: SPACES.xxl,

      // minHeight: 560,
      width: '650px',
    },
  },
  paperTitle: {
    '&&': {
      fontWeight: FONTS.WEIGHTS.bold,
      fontSize: FONTS.SIZES.xxxxl,
      textAlign: 'center',
    },
  },
  listWrapper: {
    maxHeight: 400,
    display: 'flex',
    flexDirection: 'column',
  },

  boxSubtext: {
    '&&': {
      fontSize: FONTS.SIZES.s,
      display: 'block',

      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',

      [theme.breakpoints.down('tablet')]: {
        maxWidth: 'calc(100vw - 160px)',
      },
      [theme.breakpoints.up('tablet')]: {
        maxWidth: 208,
      },
    },
  },
  boxInfoText: {
    '&&': {
      marginRight: 'auto',
      marginLeft: 'auto',

      fontWeight: FONTS.WEIGHTS.bold,
    },
  },
  borderActive: {
    '&&': {
      border: `1px solid ${theme.palette.custom.primary}`,
    },
  },
  borderInactive: {
    '&&': {
      border: `1px solid ${theme.palette.custom.grey}`,
    },
  },

  searchWrapper: {
    marginBottom: 10,
    display: 'flex',
    width: '100%',
    alignContent: 'center',
    justifyContent: 'center',
  },
}))

export default useStyles
